import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
export const orderIndexMixins = {
  mixins: [commonFuc],
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    orderTopBarList() {
      let topbarList = [
        {
          name: "全部订单",
          isActive: false,
          path: "/order",
          icon:require("@/assets/img/menuIcons/icon-order.png")
        },
        {
          name: "外卖订单",
          isActive: false,
          path: "/order/takeout",
          icon:require("@/assets/img/menuIcons/icon-ordertakeout.png")
        },
        {
          name: "堂食订单",
          isActive: false,
          path: "/order/tang",
          icon:require("@/assets/img/menuIcons/icon-ordertang.png")
        },
        {
          name: "积分兑换",
          isActive: false,
          path: "/order/pointsExchangeOrder",
          icon:require("@/assets/img/menuIcons/icon-orderpointsExchangeOrder.png")
        },
        {
          name: "团购订单",
          isActive: false,
          path: "/order/groupPurcharseOrder",
          icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
        },
        {
          name: "本地生活团购订单",
          isActive: false,
          path: "/order/BDSHGroupPurcharseOrder",
          icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
        },
        {
          name: "砍价订单",
          isActive: false,
          path: "/order/bargainingOrder",
          icon:require("@/assets/img/menuIcons/icon-orderbargainingOrder.png")
        },
        {
          name: "抖音核销订单",
          isActive: false,
          path: "/order/dy",
          icon:require("@/assets/img/menuIcons/icon-orderdy.png")
        },
      ];
      if (this.shopInfo.edcShopType == 5) {
        topbarList = [
          {
            name: "全部订单",
            isActive: false,
            path: "/order",
            icon:require("@/assets/img/menuIcons/icon-order.png")
          },
          {
            name: "积分兑换",
            isActive: false,
            path: "/order/pointsExchangeOrder",
            icon:require("@/assets/img/menuIcons/icon-orderpointsExchangeOrder.png")
          },
        ];
      }
      if (this.isDsType) {
        topbarList = [
          {
            name: "电商订单",
            isActive: false,
            path: "/order/dsOrder",
            icon:require("@/assets/img/menuIcons/icon-orderdsOrder.png")
          },
          {
            name: "预约订单",
            isActive: false,
            path: "/order/reserveOrder",
            icon:require("@/assets/img/menuIcons/icon-orderreserveOrder.png")
          },
          {
            name: "团购订单",
            isActive: false,
            path: "/order/groupPurcharseOrder",
            icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
          },
          {
            name: "本地生活团购订单",
            isActive: false,
            path: "/order/BDSHGroupPurcharseOrder",
            icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
          },
          {
            name: "砍价订单",
            isActive: false,
            path: "/order/bargainingOrder",
            icon:require("@/assets/img/menuIcons/icon-orderbargainingOrder.png")
          },
          {
            name: "积分兑换",
            isActive: false,
            path: "/order/pointsExchangeOrder",
            icon:require("@/assets/img/menuIcons/icon-orderpointsExchangeOrder.png")
          },
        ];
        if (this.shopInfo.edcShopType == 14) {
          topbarList.shift();
        }
      }
      if (this.shopInfo.edcShopType == 8) {
        topbarList = [
          {
            name: "服务订单",
            isActive: false,
            path: "/order/service",
            icon:require("@/assets/img/menuIcons/icon-orderservice.png")
          },
          {
            name: "电商订单",
            isActive: false,
            path: "/order/dsOrder",
            icon:require("@/assets/img/menuIcons/icon-orderdsOrder.png")
          },
          {
            name: "团购订单",
            isActive: false,
            path: "/order/groupPurcharseOrder",
            icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
          },
          {
            name: "本地生活团购订单",
            isActive: false,
            path: "/order/BDSHGroupPurcharseOrder",
            icon:require("@/assets/img/menuIcons/icon-ordergroupPurcharseOrder.png")
          },
          {
            name: "砍价订单",
            isActive: false,
            path: "/order/bargainingOrder",
            icon:require("@/assets/img/menuIcons/icon-orderbargainingOrder.png")
          },
          {
            name: "积分兑换",
            isActive: false,
            path: "/order/pointsExchangeOrder",
            icon:require("@/assets/img/menuIcons/icon-orderpointsExchangeOrder.png")
          },
          {
            name: "权益卡订单",
            isActive: false,
            path: "/order/equityCard",
            icon:require("@/assets/img/menuIcons/icon-orderequityCard.png")
          },
        ];
      }
      if (this.shopInfo.edcShopType == 4) {
        topbarList.push({
          name: "线下订单",
          isActive: false,
          path: "/order/offline",
          icon:require("@/assets/img/menuIcons/icon-orderoffline.png")
        });
      }
      if (this.shopInfo.edcShopType == 1) {
        topbarList.push(
          {
            name: "权益卡订单",
            isActive: false,
            path: "/order/equityCard",
            icon:require("@/assets/img/menuIcons/icon-orderequityCard.png")
          }
        )
      }
      topbarList.push({
          name: "抖音买单订单",
          isActive: false,
          path: "/order/dyOrder",
          icon:require("@/assets/img/menuIcons/icon-orderdsOrder.png")
      });
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
};
